/**
 * contactForm
 */

// Module dependencies
import 'protons';
import $ from 'jquery';

export const name = 'vehicleCalculator';

export function disable() {}

export function enable(dom) {
  const $form = $(dom).find('.vehicle-calculator-form');
  if($form.length && !$form.hasClass('mqvc-enhanced')) {
    $form.addClass('mqvc-enhanced');

    $('#edit-electric-vehicle-1').on('change', function() {
      if($(this).is(':checked')) {
        $('#edit-plug-in-hybrid-0').click();
      }
    })
  }
}

export default enable;
